import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Send, MessageSquare, ArrowLeft, User, Trash2 } from "lucide-react";
import "./bot.css"

export default function Chatbot() {
    const [open, setOpen] = useState(false);
 
    const [chatHistory, setChatHistory] = useState([]); 
    const [selectedChat, setSelectedChat] = useState(null); 
    const [userId, setUserId] = useState("");
  
    const [messages, setMessages] = useState(() => {
        return JSON.parse(localStorage.getItem("chatMessages")) || [];
    });
    const [input, setInput] = useState("");
    const [viewChat, setViewChat] = useState(false);
    const themeColor = "#7F3E98"; // Your theme color
    useEffect(() => {
        let storedUserId = localStorage.getItem("chatUserId");
        if (!storedUserId) {
          storedUserId = `user-${Date.now()}`;
          localStorage.setItem("chatUserId", storedUserId);
        }
        setUserId(storedUserId);
    

        const storedHistory = JSON.parse(localStorage.getItem("chatHistory")) || [];
        setChatHistory(storedHistory);
 
        if (selectedChat) {
          const storedMessages = JSON.parse(localStorage.getItem(selectedChat)) || [];
          setMessages(storedMessages);
        }
      }, [selectedChat]);
    
      useEffect(() => {
        if (userId) {
          localStorage.setItem(userId, JSON.stringify(messages));
        }
      }, [messages, userId]);
    
      useEffect(() => {
        localStorage.setItem("chatHistory", JSON.stringify(chatHistory));
      }, [chatHistory]);
    

    const sendMessage = async () => {
        if (!input.trim()) return;

        const userMessage = { text: input, sender: "user", timestamp: new Date().toLocaleString() };
        setMessages((prev) => [...prev, userMessage]);
        setInput("");

        try {
            const res = await fetch("http://localhost:5000/chat", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                // body: JSON.stringify({ question: input }),
                body: JSON.stringify({ question: input, userId }),
            });
            const data = await res.json();

            if (data.message) {
                setMessages((prev) => [...prev, { text: data.message, sender: "bot", timestamp: new Date().toLocaleString() }]);
            }
            setChatHistory((prevHistory) => {
                const updatedHistory = prevHistory.filter((chat) => chat.id !== userId);
                return [{ id: userId, lastMessage: input }, ...updatedHistory];
              });
        } catch (error) {
            console.error("Error fetching response:", error);
        }
    };
    const handleChatSelect = (chatId) => {
        setSelectedChat(chatId);
        setOpen(true); // Open the chat window if it's closed
      };
    const deleteChatHistory = () => {
        localStorage.removeItem("chatMessages");
        setMessages([]);
    };

    return (
        <div className=" z-50 chatbot-container">
            
            <span className="absolute  text-xs text-white bg-[#7F3E98] px-2 py-1 rounded-full">👋 We are here</span>
            {!open && (
                <motion.button
                    className="bg-[#7F3E98] text-white p-4 rounded-full shadow-lg  relative "
                    onClick={() => setOpen(true)}
                    
                    whileHover={{ scale: 1.1 }}
                    style={{ backgroundColor: themeColor }}
                >
                    {/* <span className="absolute -top-2 -left-5 text-xs text-white bg-[#7F3E98] px-2 py-1 rounded-full bg-dark">👋 We are here</span> */}
                    {/* <User size={28} className="mr-2" /> */}
                    <MessageSquare size={28} />
                </motion.button>
            )}

            {open && (
                <motion.div
                    className=" chatbot-window bg-dark shadow-xl rounded-lg overflow-hidden border border-gray-300 flex flex-col" style={{ height: "50vh" }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                >
                    <div className="bg-[#7F3E98] text-white p-4 flex justify-between items-center" style={{ backgroundColor: themeColor, color: "white" }}>
                        <button className="text-xl flex items-center gap-2" onClick={() => setViewChat(!viewChat)}>
                            <ArrowLeft size={24} />
                            <User size={24} />
                            <span>Your Chats</span>
                        </button>
                        <button className="text-xl" onClick={() => setOpen(false)}>✖</button>
                    </div>

                    {viewChat ? (
                        <div className="p-4 h-full overflow-y-auto flex flex-col gap-2 bg-gray-100">
                            <div className="flex justify-between items-center mb-2">
                                <h2 className="text-lg font-bold">Chat History</h2>
                                <button onClick={deleteChatHistory} className="text-red-500 flex items-center gap-1">
                                    <Trash2 size={18} /> Delete All
                                </button>
                            </div>
                            {messages.length > 0 ? (
                                messages.map((msg, index) => (
                                    <div
                                        key={index}
                                        className="p-3 rounded-lg cursor-pointer border bg-white shadow-md hover:bg-gray-200 transition-all"
                                        onClick={() => setViewChat(false)}
                                    >
                                        <strong>{msg.sender === "user"}</strong> {msg.text.slice(0, 30)}...
                                        <div className="text-xs text-gray-500 mt-1">{msg.timestamp}</div>
                                    </div>
                                ))
                            ) : (
                                <p className="text-center text-gray-500">No previous conversations.</p>
                            )}
                        </div>
                    ) : (
                        <div className="p-4 flex-1 overflow-y-auto flex flex-col gap-2 bg-light">
                            {messages.map((msg, index) => (
                                <div
                                    key={index}
                                    className={`p-2 rounded-md max-w-xs text-sm ${msg.sender === "user"
                                            ? "bg-[#7F3E98] self-end text-dark text-right "
                                            : "bg-gray-300 text-black text-left"
                                        }`}
                                >
                                    <strong>{msg.sender === "user"}</strong> {msg.text}
                                    <div className="text-xs text-gray-500 mt-1">{msg.timestamp}</div>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="p-2 border-t flex items-center gap-2 bg-gray-100">
                        <input
                            type="text"
                            className="flex-1 p-2 border rounded-md text-sm"
                            placeholder="Type your message..."
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            onKeyPress={(e) => e.key === "Enter" && sendMessage()}
                        />
                        <button
                            className="bg-[#7F3E98] text-white p-2 rounded-full chatbot-button"
                            onClick={sendMessage}
                            style={{ backgroundColor: themeColor }} 
                        >
                            <Send size={20} />
                        </button>
                    </div>
                </motion.div>
            )}
        </div>
    );
}
